/**
 * Created by Yaroslav S. on 16/04/24.
 * Copyright © 2024 SEVEN. All rights reserved.
 */

import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AIImages} from '../new-question-block/create-edit-dialog/ai-upload-files/ai-upload-files.interface';
import { takeUntil } from 'rxjs/operators';
import { AiRecognitionDialogService } from './ai-recognition-dialog.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { IIncludedImages } from './ai-recognition-dialog.interface';
import { FileUploadService } from '../edit-question-block/file-upload.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'curr-ai-recognition-dialog',
  templateUrl: './ai-recognition-dialog.component.html',
  styleUrls: ['./ai-recognition-dialog.component.scss'],
  providers: [AiRecognitionDialogService],
})
export class AiRecognitionDialogComponent implements OnInit, OnDestroy {
  @Input() inputData!: any;

  private readonly _onOutputData = new Subject<{ data: any; shouldClose: boolean, confirmDialog: boolean }>();
  public onOutputData = this._onOutputData.asObservable();

  form: FormGroup;
  isLoadingContent = false;
  imagesStore: {questionImages: any, markSchemeImages: any} = {questionImages: null, markSchemeImages: null}
  recognizedText: string;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private fileUploadService: FileUploadService,
    private aiRecognitionDialogService: AiRecognitionDialogService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      recognizedAnswer: new FormControl(),
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onAnswerChange(newValue: string | null) {
    console.log('Editor value:', newValue);
    this.recognizedText = newValue || '';
  }

  saveNewQuestion() {
    this._onOutputData.next({ data: { recognizedText: this.recognizedText }, shouldClose: true, confirmDialog: false });
  }

  cancelQuestion() {
    this._onOutputData.next({ data: {}, shouldClose: true, confirmDialog: true });
  }

  onLoadedFile(event) {
  }

  onSendToAI(data: { collectedFiles: AIImages[]; aiFilesType: 'question' | 'markScheme', originalFiles: any }) {
    this.isLoadingContent = true;

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    const aiData = {
      questionId: this.inputData.data.questionId,
      images: data.collectedFiles,
    };

    this.imagesStore.questionImages = data.originalFiles;

    this.aiRecognitionDialogService
      .sendToAI(this.inputData.data.studentTestId, aiData)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (resp) => {
          if (!resp.content) {
            this.isLoadingContent = false;
            this.toastr.error(this.translate.instant('shared.aiRecognitionDialog.notRecognized'));
            return;
          }

          this.recognizedText = resp.content;

          if (resp.included_images && resp.included_images.length > 0) {
            this.uploadIncludedImages(resp.included_images);
          }

          this.cdr.detectChanges();
          this.isLoadingContent = false;
        },
        (error) => {
          this.isLoadingContent = false;
          this.toastr.error(this.translate.instant('shared.aiRecognitionDialog.genericError'));
        },
      );
  }

  private uploadIncludedImages(includedImages: IIncludedImages[]) {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < includedImages.length; i++) {
      // @ts-ignore
      // const bytes = (await this.fileUploadService.download(includedImages[i].src, 'IMAGE').toPromise())?.data?.bytes;
      const image = 'data:image/png;base64,' + includedImages[i].src;
      // @ts-ignore
      includedImages[i].imgHTML = `<img src="${image}" alt="" />`;
      // @ts-ignore
      const imgHTML = `<img src="${image}" alt="" />`;
      this.recognizedText = this.recognizedText.replace(includedImages[i].code, imgHTML);
    }
  }
}
